import { createClient } from "@supabase/supabase-js";

export async function createSupabaseBrowserClient(config) {
  return createClient(config.supabase.url, config.supabase.anonKey, {
    auth: {
      autoRefreshToken: true,
      detectSessionInUrl: true,
      persistSession: true,
    },
  });
}

export async function getSupabaseSession(client) {
  const { data, error } = await client.auth.getSession();
  if (error) {
    console.warn("getSupabaseSession error (treating as no session):", error.message);
    return null;
  }
  return data.session || null;
}

export async function signInSupabaseWithPassword(client, email, password) {
  const { error } = await client.auth.signInWithPassword({ email, password });
  if (error) throw error;
}

export async function signOutSupabase(client) {
  const { error } = await client.auth.signOut();
  if (error) throw error;
}

export function subscribeToSupabaseAuth(client, callback) {
  const { data } = client.auth.onAuthStateChange((event, session) => {
    callback(event, session || null);
  });
  return () => {
    data.subscription.unsubscribe();
  };
}

export async function resetPasswordForEmail(client, email, redirectTo) {
  const { error } = await client.auth.resetPasswordForEmail(email, { redirectTo });
  if (error) throw error;
}

export async function updateUserPassword(client, newPassword) {
  const { error } = await client.auth.updateUser({ password: newPassword });
  if (error) throw error;
}
